'use client';

import React, { Fragment, useCallback, useState, useRef } from 'react';
// import { PopupApiRes } from '@wconcept/wconcept-ui-renewal/@types/popup';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ItemsSwiper from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsSwiper';
import ModalTodayCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalTodayCloseBtn';
import SwiperPagination from '@wconcept/wconcept-ui-renewal/components/molecules/SwiperPagination';
import SwiperNavigation from '@wconcept/wconcept-ui-renewal/components/molecules/SwiperNavigation';
import { BottomPopup } from '@wconcept/wconcept-common/models/renewal/popup';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import { Swiper as SwiperClass } from 'swiper/types';
import * as S from './style';

interface IProps {
  onSubmit?: () => void;
  onClose?: () => void;
  value: {
    items: BottomPopup[];
    isDesktop?: boolean;
    onClickButton?: (param: any, i: number) => void;
  };
}

const MainSlideModal2 = ({ onSubmit, onClose, value }: IProps) => {
  const { items, isDesktop, onClickButton } = value;
  const [isVisible, setIsVisible] = useState(false);
  const swiperRef = useRef<SwiperClass | null>(null);

  // EVENT HANDLER : onSubmit
  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  // EVENT HANDLER : onClose
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.MainSlideModal2>
      <div className="content">
        <ItemsSwiper
          autoplay={{ delay: 2000, pauseOnMouseEnter: true }}
          navigation={
            isDesktop
              ? {
                  prevEl: '.mainSlideModal-navigation .swiper-button-prev',
                  nextEl: '.mainSlideModal-navigation .swiper-button-next',
                }
              : undefined
          }
          navigationEl={
            isDesktop ? (
              <SwiperNavigation
                size="xsmall"
                className="mainSlideModal-navigation"
                onClickAutoplayControlBtn={state => {
                  if (swiperRef.current) {
                    if (state) {
                      swiperRef.current?.autoplay.stop();
                    } else {
                      swiperRef.current?.autoplay.start();
                    }
                  }
                }}
              />
            ) : undefined
          }
          onSwiper={
            isDesktop
              ? (swiper: SwiperClass) => {
                  if (swiper) {
                    swiperRef.current = swiper;
                  }
                }
              : undefined
          }
          pagination={items.length > 1 ? { type: 'fraction' } : false}
        >
          {items?.slice(0, 10).map((v, i) => (
            <Fragment
              key={
                v.imageUrl != null && v.imageUrl !== ''
                  ? `${v.imageUrl}-${i}`
                  : `main-slide-modal-item-${i}`
              }
            >
              <Button
                onClick={() => {
                  onClickButton?.(v, i);
                }}
              >
                <Img
                  src={getResizeImageUrl(v.imageUrl, isDesktop ? '600' : '750')}
                  alt="자세히보기"
                  onLoadingComplete={() => setIsVisible(true)}
                  priority={i < 3}
                />
                {v.bottomPopupType !== 'IMAGE' && (
                  <div className="area-text">
                    <div className="text-wrap">
                      <div className="title">
                        {v.bottomPopupTitle1 && (
                          <Text
                            className="title1"
                            color={v.bottomPopupTitleColor || '#000'}
                          >
                            {v.bottomPopupTitle1}
                          </Text>
                        )}
                        {v.bottomPopupTitle2 && (
                          <Text
                            className="title2"
                            color={v.bottomPopupTitleColor || '#000'}
                          >
                            {v.bottomPopupTitle2}
                          </Text>
                        )}
                      </div>
                      <div className="sub-title">
                        {v.bottomPopupSubTitle1 && (
                          <Text
                            className="sub-title1"
                            color={v.bottomPopupSubTitleColor || '#000'}
                          >
                            {v.bottomPopupSubTitle1}
                          </Text>
                        )}
                        {v.bottomPopupSubTitle2 && (
                          <Text
                            className="sub-title2"
                            color={v.bottomPopupSubTitleColor || '#000'}
                          >
                            {v.bottomPopupSubTitle2}
                          </Text>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Button>
              {v.buttonTitle && (
                <Button
                  className="btn-link"
                  onClick={() => onClickButton?.(v, i)}
                >
                  {v.buttonTitle}
                </Button>
              )}
            </Fragment>
          ))}
        </ItemsSwiper>
      </div>
      <ModalTodayCloseBtn onTodayClose={handleSubmit} onClose={handleClose} />
    </S.MainSlideModal2>
  );
};

export default MainSlideModal2;
